export default class BadParserError extends Error {}
